let tableContainerSelector = '#jsSpecCompareTabs';
let highlightSelector = '.jsSpecCompareHighlight';
let compareButtonSelector = '.jsSpecCompareTabsShowDiff';
$(function () {
    initTabs();
    checkboxShowOrHideColumn();
    highlightDifference();
});

function initTabs() {
    $(tableContainerSelector).tabs({
        active: 0,
    });
    
}

function checkboxShowOrHideColumn() {
    $('.jsSpecCompareTabsSwitchCol').on('change', function () {
        let $self = $(this);
        let rowIndex = $self.data('row-index');
        let $table = $(`${tableContainerSelector} table:visible`);
        $(`tr > *`, $table).filter(`:nth-child(${rowIndex})`).toggle();
        $(`${compareButtonSelector}:visible`).trigger('change');
    });
    
    //lets see what checkboxes are checked on init
    $('.jsSpecCompareTabsSwitchCol').not(":checked").each(function () {
        let $self = $(this);
        let rowIndex = $self.data('row-index');
        let $table = $(`${tableContainerSelector} table`);
               
        $(`tr > *`, $table).filter(`:nth-child(${rowIndex})`).hide();
    });  
}

function highlightDifference() {
    $(compareButtonSelector).on('change', function () {
        let highlightClass = highlightSelector.slice(1);
        let $table = $(`${tableContainerSelector} table:visible`);
        $('tr', $table).removeClass(highlightClass);
        if ($(this).prop('checked')) {
            $table.find('tbody tr').each(function (ind, elem) {
                let equal = true;
                let tds = $(elem).find('td:visible');
                let tdsArr = [].map.call(tds, function (el) {
                    return $(el).text();
                });
                if(tdsArr.length) {
                    tdsArr.reduce(function (prev, curr) {
                        if (prev.toLowerCase().replace(/\s/g, '') !== curr.toLowerCase().replace(/\s/g, '')) equal = false;
                        return prev;
                    });
                }

                if (!equal) $(elem).addClass(highlightClass);
            })
        }
    });
}
